import { render } from "./highSeas.vue?vue&type=template&id=1a24b2ae&scoped=true"
import script from "./highSeas.vue?vue&type=script&lang=js"
export * from "./highSeas.vue?vue&type=script&lang=js"

import "./highSeas.vue?vue&type=style&index=0&id=1a24b2ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a24b2ae"

export default script